import { LicenceOrganisationRule } from "@/Common/Api/MedfarDictionaries/Dto/Responses/LicenceOrganisationRule";

/**
 * @description Used to be EmployeeComposite
 */
class License {
    public LicenceNumber: string;
    public Id: string;
    public IssuingLicenseOrganizationRuleId: string;
    public ShouldUpdateLicenseOrganizationRuleIdOnNextLogin: boolean;
    public PermitTypeLookupId: string;

    private _obsoleteLicenseOrganizationRuleId: string;

    constructor(fields?: Partial<License>) {
        Object.assign(this, fields);
    }

    public get ObsoleteLicenseOrganizationRuleId(): string {
        return this._obsoleteLicenseOrganizationRuleId;
    }

    public shouldUpdateLicenseOrganizationRuleIdOnNextLogin(): boolean {
        if (!this.ObsoleteLicenseOrganizationRuleId)
            this._obsoleteLicenseOrganizationRuleId = this.IssuingLicenseOrganizationRuleId;

        return this.ShouldUpdateLicenseOrganizationRuleIdOnNextLogin;
    }

    public static getSuffix(license: License): string {
        if (!license)
            return "";

        const licenseOrganization = cacheStore.AllLicenseOrganizationRulesById[license?.IssuingLicenseOrganizationRuleId] ?? null;

        if (!licenseOrganization?.LicenceOrganisationCode || licenseOrganization.LicenceOrganisationCode == "OTH")
            return "";

        return `.${licenseOrganization.OrganisationCode}.${licenseOrganization.StateCode}.${licenseOrganization.CountryCode}`;
    }

    public static getIssuingOrgRule(license: License): LicenceOrganisationRule {
        if (!license)
            return null;

        const ruleId = license.IssuingLicenseOrganizationRuleId;
        return cacheStore.AllLicenseOrganizationRulesById[ruleId] ?? null; // avoid undefined
    }
}

export { License };
